var React = require('react');

function Gallery (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.419 0H2.9A2.894 2.894 0 000 2.9v8.2A2.894 2.894 0 002.9 14h11.519a2.894 2.894 0 002.9-2.9V2.9a2.894 2.894 0 00-2.9-2.9zm-.128 4.3a1.258 1.258 0 11-1.258-1.258A1.26 1.26 0 0114.292 4.3zm.128 8.13H2.9a1.338 1.338 0 01-1.332-1.33v-.036l4.156-4.776a1.124 1.124 0 011.714 0l2.716 3.117a.21.21 0 00.31 0l1.057-1.167a1.049 1.049 0 011.549 0l2.661 2.917a1.324 1.324 0 01-1.312 1.277z"}));
}

Gallery.defaultProps = {"height":"14","width":"18"};

module.exports = Gallery;

Gallery.default = Gallery;
